/* JinnKo preview theme. Catalog data stays on the storefront; no admin token or third-party service. */
(() => {
  'use strict';
  const normalize = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
  const family = p => {
    if (typeof p.family === 'string') return p.family;
    const c = (p.collections || []).join(' ');
    const t = normalize(`${p.title} ${p.type} ${p.vendor} ${(p.tags || []).join(' ')}`);
    if (/funko-pop/.test(c) || /funko/.test(t)) return 'funko';
    if (/youtooz/.test(c) || /youtooz/.test(t)) return 'youtooz';
    if (/accessories|binders|sleeves|playmats/.test(c) || /\b(binder|sleeves|playmat|deck box)\b/.test(normalize(`${p.title} ${p.type}`))) return '';
    if (/pokemon|english-singles|japanese-singles|foreign-language-pokemon/.test(c) || /pokemon|pokémon/.test(t)) return 'pokemon';
    if (/cookie-?run|cookierun/.test(c) || /cookie\s?run|braverse/.test(t)) return 'cookierun';
    if (/my-little-pony/.test(c) || /my little pony/.test(t)) return 'mlp';
    if (/op-singles|one-piece/.test(c) || /one piece/.test(t)) return 'onepiece';
    return '';
  };
  const graded = p => typeof p.graded === 'boolean' ? p.graded : (p.collections||[]).includes('slabs') || /\b(graded|slabbed|slab|psa|cgc|bgs|sgc|beckett)\b/.test(normalize(`${p.title} ${p.type}`)) || (p.tags || []).some(tag => /^(graded(?: cards?)?|slabs?|slabbed|psa|cgc|bgs|sgc|beckett)$/.test(normalize(tag).trim()));
  const single = p => {
    if (typeof p.single === 'boolean') return p.single;
    const type=normalize(p.type),tags=(p.tags||[]).map(normalize);
    if (/single/.test(type) || type.trim()==='trading card' || graded(p)) return true;
    // Explicit sealed inventory wins over broad legacy "Singles" tags.
    if (/sealed/.test(type) || tags.some(t=>/^(factory sealed|sealed product)$/.test(t))) return false;
    if (/\b(booster (box|pack)|starter deck|sleeves|card protectors|binder|playmat|deck box)\b/.test(normalize(`${p.title} ${p.type}`))) return false;
    return /single/.test(normalize(`${(p.collections||[]).join(' ')} ${tags.join(' ')}`));
  };
  const searchText = p => normalize(`${p.title} ${p.type} ${p.vendor} ${p.description} ${(p.tags || []).join(' ')} ${(p.collections || []).join(' ')} ${p.variantText}`);
  function filterCatalog(products, category, query = '', includeSoldOut = false) {
    const terms = normalize(query).trim().split(/\s+/).filter(Boolean);
    const departments = {pokemon:['pokemon','english-singles','japanese-singles','other-foreign-language-pokemon-singles'],cookierun:['cookie-run-tcg','cookierun-braverse-singles'],mlp:['my-little-pony'],onepiece:['op-singles']};
    return products.filter(p => {
      if (!Number.isFinite(p.price) || (!includeSoldOut && p.variantCount < 1)) return false;
      if (category === 'pins') {
        if (single(p) || graded(p)) return false;
        if (p.pins !== true && !/\bpins?\b/.test(normalize(`${p.title} ${p.type} ${(p.tags || []).join(' ')} ${(p.collections || []).join(' ')}`))) return false;
      } else if (category && category !== 'all' && family(p) !== category && !(p.collections||[]).some(handle=>(departments[category]||[]).includes(handle))) return false;
      return terms.every(term => searchText(p).includes(term));
    });
  }
  function sortCatalog(products, order, sealedFirst = false, query = '') {
    const copy = products.slice();
    const name = (a,b) => a.title.localeCompare(b.title) || String(a.id).localeCompare(String(b.id));
    const newest = (a,b) => (Number(b.created)||0) - (Number(a.created)||0) || Number(b.id)-Number(a.id) || name(a,b);
    if (order === 'price-ascending') copy.sort((a,b) => a.price - b.price || name(a,b));
    else if (order === 'price-descending') copy.sort((a,b) => b.price - a.price || name(a,b));
    else if (order === 'title' || order === 'title-ascending') copy.sort(name);
    else if (order === 'title-descending') copy.sort((a,b)=>name(b,a));
    else if (order === 'created-descending') copy.sort(newest);
    else if (order === 'created-ascending') copy.sort((a,b)=>newest(b,a));
    else if (sealedFirst) copy.sort((a,b) => Number(a.variantCount < 1) - Number(b.variantCount < 1) || Number(single(a)) - Number(single(b)) || newest(a,b));
    else if (query) {
      const q = normalize(query).trim();
      const relevance = p => normalize(p.title) === q ? 3 : normalize(p.title).includes(q) ? 2 : 1;
      copy.sort((a,b) => relevance(b) - relevance(a) || name(a,b));
    }
    else copy.sort((a,b) => Number(a.variantCount < 1) - Number(b.variantCount < 1) || newest(a,b));
    return copy;
  }
  const singleGroups = ['pokemon-en','pokemon-jp','pokemon-int','cookierun','onepiece','slabs'];
  function singleGroup(p) {
    if (singleGroups.includes(p.singleGroup)) return p.singleGroup;
    if (graded(p)) return 'slabs';
    if (!single(p)) return '';
    const game=family(p);
    if(game==='cookierun'||game==='onepiece')return game;
    if(game!=='pokemon')return '';
    const language=normalize(`${(p.tags||[]).join(' ')} ${(p.collections||[]).join(' ')} ${p.title}`);
    if(/japanese|japan|\[jp\]|\bjpn?\b/.test(language))return 'pokemon-jp';
    if(/foreign|chinese|korean|french|german|italian|spanish|portuguese|thai|indonesian|\[(ch|cn|kr|ko)\]/.test(language))return 'pokemon-int';
    return /english|\ben\b/.test(language)?'pokemon-en':'pokemon-int';
  }
  function filterSingles(products, groups = singleGroups) {
    return products.filter(p => groups.includes(singleGroup(p)));
  }
  function randomFeatured(products, rng = Math.random) {
    const pool = products.filter(p => p.variantCount > 0 && Number.isFinite(p.price) && !graded(p));
    const used = new Set();
    const pick = (candidates, count) => {
      const choices = candidates.filter(p => !used.has(p.id));
      const picked = [];
      for (let i = 0; i < count && choices.length; i++) {
        const index = Math.min(choices.length - 1, Math.floor(rng() * choices.length));
        const p = choices.splice(index, 1)[0]; used.add(p.id); picked.push(p);
      }
      return picked;
    };
    const result = [...pick(pool.filter(p => family(p) === 'pokemon'),5), ...pick(pool.filter(p => family(p) === 'cookierun'),3), ...pick(pool.filter(p => family(p) === 'funko'),1), ...pick(pool.filter(p => family(p) === 'youtooz'),1)];
    result.push(...pick(pool,12 - result.length));
    return result;
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = {normalize,family,graded,single,singleGroup,filterCatalog,filterSingles,sortCatalog,randomFeatured};
  if (typeof document === 'undefined') return;
  const config = window.JinnKo || {root:'/',currency:'USD',locale:'en'};
  const route = path => `${config.root.replace(/\/$/,'')}/${path.replace(/^\//,'')}`;
  const money = cents => new Intl.NumberFormat(config.locale,{style:'currency',currency:config.currency}).format(cents/100);
  const escape = value => String(value == null ? '' : value).replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const safeURL = url => {
    try { const u = new URL(url,location.origin); return ['https:','http:'].includes(u.protocol) ? escape(u.href) : '#'; } catch { return '#'; }
  };
  const announce = message => { const el = document.querySelector('#jk-status'); if (el) el.textContent = message; };

  // Missing photos are independent of availability and product tags.
  const productImageSelector = '.jk-card-image img:not(.jk-sold-overlay), .jk-gallery img, .jk-cart-line img';
  function useImageFallback(image) {
    if (!config.imageUnavailable) return;
    const fallback = new URL(config.imageUnavailable, location.origin).href;
    if (image.src === fallback) return;
    image.removeAttribute('srcset');
    image.removeAttribute('sizes');
    image.classList.add('jk-image-unavailable');
    image.alt = `Image unavailable${image.alt ? ` for ${image.alt}` : ''}`;
    image.src = fallback;
  }
  document.addEventListener('error', event => {
    if (event.target instanceof HTMLImageElement && event.target.matches(productImageSelector)) useImageFallback(event.target);
  }, true);
  document.querySelectorAll(productImageSelector).forEach(image => {
    if (image.complete && !image.naturalWidth) useImageFallback(image);
  });

  // Remember display preference without storing customer or account information.
  let appearance = 'dark';
  try { appearance = localStorage.getItem('jinnko-appearance') || 'dark'; } catch {}
  function setAppearance(mode) {
    appearance = mode === 'light' ? 'light' : 'dark';
    document.documentElement.dataset.appearance = appearance;
    document.querySelectorAll('[data-theme-toggle]').forEach(button => {
      button.textContent = appearance === 'dark' ? 'Light mode' : 'Dark mode';
      button.setAttribute('aria-label',`Switch to ${appearance === 'dark' ? 'light' : 'dark'} mode`);
    });
    try { localStorage.setItem('jinnko-appearance',appearance); } catch {}
  }
  setAppearance(appearance);
  // Shopify's followed-state label is black inside its open shadow root.
  // Match only that label to the theme; keep the native Shop action and branding.
  const shopFollow = document.querySelector('.jk-shop-follow shop-follow-button');
  if(shopFollow && window.customElements) {
    customElements.whenDefined('shop-follow-button').then(()=>{
      let attempts=0;
      const install=()=>{
        const root=shopFollow.shadowRoot;
        if(!root) {if(++attempts<120)requestAnimationFrame(install);return;}
        const keepStyle=()=>{
          if(root.querySelector('[data-jk-shop-contrast]'))return;
          const style=document.createElement('style');
          style.setAttribute('data-jk-shop-contrast','');
          style.textContent='button > span.text-black { color: var(--jk-shop-follow-label, #111) !important; }';
          root.append(style);
        };
        keepStyle();
        new MutationObserver(keepStyle).observe(root,{childList:true,subtree:true});
      };
      install();
    });
  }
  document.querySelectorAll('[data-theme-toggle]').forEach(b => b.addEventListener('click',()=>setAppearance(appearance === 'dark' ? 'light' : 'dark')));
  const mobileMenu = document.querySelector('.jk-menu');
  if (mobileMenu && matchMedia('(max-width:700px)').matches) mobileMenu.open = false;
  matchMedia('(min-width:701px)').addEventListener('change', e => { if (e.matches && mobileMenu) mobileMenu.open = true; });
  const menuToggle=document.querySelector('[data-menu-open]');
  const departments=document.querySelector('.jk-sidebar nav');
  if(menuToggle && departments && typeof HTMLDialogElement !== 'undefined') {
    const drawer=document.createElement('dialog');
    drawer.id='jk-mobile-menu';drawer.className='jk-mobile-menu';
    drawer.setAttribute('aria-labelledby','jk-mobile-menu-title');
    drawer.innerHTML='<div class="jk-mobile-menu-heading"><h2 id="jk-mobile-menu-title">Shop JinnKo</h2><button type="button" class="jk-close" data-menu-close aria-label="Close menu">×</button></div>';
    drawer.append(departments.cloneNode(true));
    document.body.append(drawer);
    const close=()=>drawer.close();
    menuToggle.addEventListener('click',()=>{
      drawer.showModal();menuToggle.setAttribute('aria-expanded','true');
      document.documentElement.classList.add('jk-menu-open');
    });
    drawer.querySelector('[data-menu-close]').addEventListener('click',close);
    drawer.addEventListener('close',()=>{
      menuToggle.setAttribute('aria-expanded','false');
      document.documentElement.classList.remove('jk-menu-open');
      menuToggle.focus({preventScroll:true});
    });
    drawer.addEventListener('click',event=>{
      if(event.target.closest('a'))close();
      if(event.target===drawer){const box=drawer.getBoundingClientRect();if(event.clientX<box.left||event.clientX>box.right||event.clientY<box.top||event.clientY>box.bottom)close();}
    });
    matchMedia('(min-width:701px)').addEventListener('change',event=>{if(event.matches && drawer.open)close();});
  }

  // Limit concurrency across all departmental sources, not separately per collection.
  const catalogQueue = []; let catalogRequests = 0;
  function boundedCatalogFetch(url, priority = false) {
    return new Promise((resolve,reject)=>{
      const run=async()=>{
        catalogRequests++;
        try { resolve(await fetch(url,{credentials:'same-origin',headers:{Accept:'text/html'}})); }
        catch(error) { reject(error); }
        finally { catalogRequests--; catalogQueue.shift()?.(); }
      };
      if(catalogRequests<4) run(); else if(priority) catalogQueue.unshift(run); else catalogQueue.push(run);
    });
  }
  const loads = new Map();
  async function loadCatalog(source, progress, compact = false) {
    const key = `${source}|${compact}`;
    if (loads.has(key)) return loads.get(key);
    const promise = (async () => {
      const requestPage = async page => {
        const u = new URL(source,location.origin);
        u.search = ''; u.searchParams.set('sort_by','created-descending');u.searchParams.set('view',compact?'jinnko-order':'jinnko-data'); u.searchParams.set('page',page);
        const previewID = new URLSearchParams(location.search).get('preview_theme_id');
        if (previewID) u.searchParams.set('preview_theme_id',previewID);
        // This is a Liquid collection view. Shopify serves it as text/html even though its body is JSON.
        const response = await boundedCatalogFetch(u);
        if (!response.ok) throw new Error(`Catalog could not be loaded (${response.status}).`);
        const result = await response.json();
        if (!Array.isArray(result.products) || !Number.isInteger(result.pages)) throw new Error('Catalog data is unavailable.');
        if (result.total > 25000) throw new Error('This catalog needs a dedicated search index.');
        return result;
      };
      const first = await requestPage(1);
      const pages = new Map([[1,first.products]]);
      let next = 2, completed = 1;
      progress?.(completed,first.pages);
      // Four bounded requests load a small ordering index; visible cards get live details separately.
      await Promise.all(Array.from({length:Math.min(4,Math.max(0,first.pages-1))},async()=>{
        while (next <= first.pages) {
          const page = next++; const result = await requestPage(page); pages.set(page,result.products);
          progress?.(++completed,first.pages);
        }
      }));
      const rows = Array.from(pages).sort((a,b)=>a[0]-b[0]).flatMap(p=>p[1]);
      return Array.from(new Map(rows.map(p=>[p.id,p])).values());
    })();
    loads.set(key,promise);
    try { return await promise; } catch(e) { loads.delete(key); throw e; }
  }
  async function hydrateProducts(products) {
    if (!products.length) return [];
    const chunks=[];let batch=[],length=0;
    for(const p of products){
      if(!p.handle)throw new Error('Product details unavailable');
      if(batch.length>=10||length+p.handle.length>1500){chunks.push(batch);batch=[];length=0;}
      batch.push(p);length+=p.handle.length+1;
    }
    if(batch.length)chunks.push(batch);
    const groups=await Promise.all(chunks.map(async chunk=>{
      const url=new URL(route('search'),location.origin);url.searchParams.set('view','jinnko-cards');url.searchParams.set('q',chunk.map(p=>p.handle).join(','));url.searchParams.set('type','product');
      const preview=new URLSearchParams(location.search).get('preview_theme_id');if(preview)url.searchParams.set('preview_theme_id',preview);
      const response=await boundedCatalogFetch(url);if(!response.ok)throw new Error('Product details unavailable');const data=await response.json();if(!Array.isArray(data.products))throw new Error('Product details unavailable');return data.products;
    }));
    const live=new Map(groups.flat().map(p=>[String(p.id),p]));
    return products.flatMap(p=>{const detail=live.get(String(p.id));return detail?[{...p,...detail,single:p.single,family:p.family,graded:p.graded,singleGroup:p.singleGroup,pins:p.pins}]:[];});
  }
  function cardPriceHTML(p) {
    const comparison = Number(p.compareAt);
    const sale = Number.isFinite(comparison) && comparison > p.price;
    const old = sale ? `<del class="jk-card-compare"><span class="jk-sr">Regular price </span>${escape(money(comparison))}</del>` : '';
    return `${old}<span class="jk-current-price">${sale?'<span class="jk-sr">Sale price </span>':''}${escape(money(p.price))}</span>`;
  }
  const cardSwatches={red:'#c73b40',blue:'#3b66be',green:'#4c805b',black:'#151515',white:'#fff',purple:'#8057a4',pink:'#e7a2bd',yellow:'#edcf48',orange:'#d87c31',grey:'#999',gray:'#999',brown:'#785641',sage:'#a3b291','sky blue':'#83c8ed'};
  function cardChoicesHTML(p) {
    return `<div class="jk-card-variants" role="group" aria-label="In-stock variants for ${escape(p.title)}">${(p.variants||[]).filter(v=>v.title!=='Default Title').map(v=>{
      const purchase=!v.color&&!p.sellingPlan;
      const button=`<button class="jk-card-choice${v.color?' jk-card-choice-color':''}" type="button" aria-label="${purchase?'Add ':''}${escape(v.title)}${purchase?' to cart':''}" title="${escape(v.title)}" data-card-choice="${v.id}" data-image="${v.image||p.image?safeURL(v.image||p.image):''}" data-image-alt="${escape(p.title+' — '+v.title)}" data-price="${v.price}" data-compare="${v.compareAt||0}" aria-pressed="${String(v.id)===String(p.variant)}">${v.color?`<span class="jk-color" style="background:${cardSwatches[normalize(v.color)]||'linear-gradient(135deg,#ddd 45%,#777 46%,#777 54%,#ddd 55%)'}"></span>`:escape(v.title)}</button>`;
      return purchase?`<div class="jk-variant-purchase" data-variant-purchase="${v.id}">${button}<div class="jk-card-counter jk-variant-counter" hidden><button type="button" data-card-step="-1" aria-label="Decrease ${escape(v.title)} quantity">−</button><span class="jk-variant-count-label">${escape(v.title)} <span data-card-quantity>0</span></span><button type="button" data-card-step="1" aria-label="Increase ${escape(v.title)} quantity">+</button></div></div>`:button;
    }).join('')}</div>`;
  }
  function cardImageSrcset(src) {
    return [200,300,450,600].map(width => {
      const url = new URL(src,location.origin);
      url.searchParams.set('width',width);
      return url.href + ' ' + width + 'w';
    }).join(', ');
  }
  function selectCardImage(card, choice) {
    const image = card.querySelector('.jk-card-image img:not(.jk-sold-overlay)');
    if (!image || !choice.dataset.image) return;
    const url = new URL(choice.dataset.image,location.origin);
    if (!['https:','http:'].includes(url.protocol)) return;
    image.classList.remove('jk-image-unavailable');
    image.alt = choice.dataset.imageAlt || card.querySelector('.jk-card-title').textContent.trim();
    image.srcset = cardImageSrcset(url.href);
    image.sizes = '(max-width:700px) 45vw, 18vw';
    image.src = url.href;
  }
  function cardHTML(p, imageLoading='lazy') {
    const soldOut = p.variantCount < 1;
    const direct = p.variantCount > 0 && !p.sellingPlan;
    const button = soldOut ? '<button class="jk-secondary" type="button" disabled>Sold out</button>' : direct
      ? `<form action="${route('cart/add')}" method="post" class="jk-add-form"><input type="hidden" name="id" value="${p.variant}"><button class="jk-secondary" type="submit">Add to cart</button></form>`
      : `<a class="jk-secondary" href="${safeURL(p.url)}" aria-label="Choose options for ${escape(p.title)}">Options</a>`;
    const counter=direct?`<div class="jk-card-counter" hidden><button type="button" data-card-step="-1" aria-label="Decrease quantity for ${escape(p.title)}">−</button><span data-card-quantity aria-label="Cart quantity">0</span><button type="button" data-card-step="1" aria-label="Increase quantity for ${escape(p.title)}">+</button></div>`:'';
    const overlay = soldOut && config.soldOutOverlay ? `<img class="jk-sold-overlay" src="${safeURL(config.soldOutOverlay)}" alt="Sold out" loading="lazy">` : '';
    const imageSet=p.image?escape(cardImageSrcset(p.image)):'';
    const image = `<img${p.image ? '' : ' class="jk-image-unavailable"'} src="${safeURL(p.image || config.imageUnavailable)}" width="300" height="300" loading="${imageLoading}"${p.image?` srcset="${imageSet}" sizes="(max-width:700px) 45vw, 18vw"`:""} alt="${escape(p.image ? p.title : `Image unavailable for ${p.title}`)}">`;
    const textPurchases=direct&&(p.variants||[]).some(v=>v.title!=='Default Title')&&!(p.variants||[]).some(v=>v.color);
    return `<article data-product-id="${escape(p.id)}" data-card-single-group="${escape(singleGroup(p))}" data-card-price="${p.price}" data-card-compare="${p.compareAt||0}" data-card-available-count="${p.variantCount}" class="jk-card${soldOut?' jk-card-sold-out':''}${textPurchases?' jk-card-text-purchases':''}" ${direct?`data-card-variant="${p.variant}"`:''}><a class="jk-card-image" href="${safeURL(p.url)}">${image}${overlay}</a><a class="jk-card-title" href="${safeURL(p.url)}" title="${escape(p.title)}"><span>${escape(p.title)}</span></a>${cardChoicesHTML(p)}<div class="jk-card-buy"><div class="jk-card-pricing"><p class="jk-card-price">${cardPriceHTML(p)}</p><p class="jk-stock">${soldOut?'Sold out':'In stock'}</p></div><div class="jk-card-action">${button}${counter}</div></div></article>`;
  }
  async function startCatalog(section) {
    const mode = section.dataset.jkCatalog;
    const params = new URLSearchParams(location.search);
    const query = mode === 'search' ? params.get('q') || '' : '';
    const nativeCategory = section.dataset.category || '';
    const category = mode === 'collection' ? nativeCategory || params.get('jinnko_category') || '' : '';
    const labels = {pokemon:'Pokémon',cookierun:'CookieRun',mlp:'My Little Pony TCG',onepiece:'One Piece',pins:'Pins'};
    const status = section.querySelector('[data-catalog-status]');
    const grid = section.querySelector('[data-catalog-grid]');
    const sort = section.querySelector('[data-catalog-sort]');
    const more = section.querySelector('[data-catalog-more]');
    const native = section.querySelector('[data-native-pagination]');
    if (category !== nativeCategory) delete section.dataset.catalogReady;
    section.dataset.category = category;
    if (category && labels[category]) section.querySelector('[data-catalog-title]').textContent = labels[category];
    if (mode === 'search' && !query.trim()) { grid.replaceChildren(); if(native) native.hidden=true; return; }
    if (sort) sort.disabled = true;
    const singleFilters=section.querySelector('[data-single-filters]');
    const typeInputs=singleFilters ? [...singleFilters.querySelectorAll('[data-single-type]')] : [];
    const savedTypes=params.get('single_types');
    if(singleFilters && savedTypes!==null){
      const chosen=new Set(savedTypes.split(',').filter(type=>singleGroups.includes(type)));
      typeInputs.forEach(input=>{input.checked=chosen.has(input.dataset.singleType);});
    }
    const selectedTypes=()=>typeInputs.filter(input=>input.checked&&!input.disabled).map(input=>input.dataset.singleType);
    const rememberTypes=()=>{
      const chosen=typeInputs.filter(input=>input.checked).map(input=>input.dataset.singleType);
      const url=new URL(location.href);url.searchParams.delete('page');
      if(chosen.length===typeInputs.length)url.searchParams.delete('single_types');
      else url.searchParams.set('single_types',chosen.join(',')||'none');
      history.replaceState(null,'',url);
    };
    let catalogApplyTypes=null,typeRevision=0;
    const hideNativeTypes=()=>{
      if(!singleFilters)return;
      const chosen=new Set(selectedTypes());
      if(chosen.size)grid.querySelector('.jk-empty')?.remove();
      grid.querySelectorAll('.jk-card').forEach(card=>{card.hidden=!chosen.has(card.dataset.cardSingleGroup);});
    };
    const applyEarlyTypes=async()=>{
      const token=++typeRevision;hideNativeTypes();
      if(catalogApplyTypes)return catalogApplyTypes();
      const chosen=selectedTypes();
      const visible=grid.querySelectorAll('.jk-card:not([hidden])').length;
      status.textContent=`${visible} shown`;
      if(!chosen.length){grid.innerHTML='<p class="jk-empty">No products match these types. Choose another type or use Show all types.</p>';return;}
      if(visible>=20)return;
      const sources=[...new Set(typeInputs.filter(input=>chosen.includes(input.dataset.singleType)).map(input=>input.dataset.singleSource))];
      const heads=await Promise.all(sources.map(async source=>{
        const url=new URL(source,location.origin);url.searchParams.set('view','jinnko-first');url.searchParams.set('sort_by','created-descending');url.searchParams.set('filter.v.availability','1');
        const preview=params.get('preview_theme_id');if(preview)url.searchParams.set('preview_theme_id',preview);
        const response=await boundedCatalogFetch(url,true);if(!response.ok)throw new Error('Selected products unavailable');return (await response.json()).products;
      }));
      if(token!==typeRevision||catalogApplyTypes)return;
      const pool=Array.from(new Map(heads.flat().map(p=>[String(p.id),p])).values());
      const first=sortCatalog(filterSingles(pool.filter(p=>p.variantCount>0),selectedTypes()),'default',true).slice(0,20);
      mergeSearchCards(grid,first);status.textContent=`${first.length} shown`;section.dataset.catalogReady='native';
    };
    if(singleFilters){
      hideNativeTypes();
      const apply=()=>{rememberTypes();applyEarlyTypes().catch(()=>{status.textContent='These types could not load. Please try again.';});};
      singleFilters.addEventListener('change',apply);
      singleFilters.querySelector('[data-single-reset]').addEventListener('click',()=>{typeInputs.forEach(input=>{input.checked=true;});apply();});
    }
    if(status)status.textContent=`${grid.querySelectorAll('.jk-card:not([hidden])').length} shown`;
    try {
      const sourceList = section.querySelector('[data-catalog-sources]');
      const sources = sourceList ? JSON.parse(sourceList.textContent) : [];
      // Ordering and the first live batch are independent: do not put them in a waterfall.
      const catalogPromise = Promise.all((sources.length?sources:[section.dataset.source]).map(source=>loadCatalog(source,undefined,mode==='collection')));
      // Attach a handler immediately while the initial batch is being requested.
      catalogPromise.catch(()=>{});
      if(singleFilters && savedTypes!==null)await applyEarlyTypes().catch(error=>console.warn('JinnKo selected first batch:',error.message));
      const requestedSort=params.get('jinnko_sort')||params.get('sort_by');
      const defaultOrder=!['price-ascending','price-descending','title','title-ascending','title-descending','created-ascending'].includes(requestedSort)&&params.get('jinnko_sort')!=='created-descending';
      if(!defaultOrder)delete section.dataset.catalogReady;
      if(defaultOrder&&(!singleFilters||savedTypes===null)&&grid.querySelectorAll('.jk-card').length<20) {
        try {
        const bootstrapRevision=typeRevision;
        // Skip sold-out source pages to fill one initial batch, before the full index.
        const heads=await Promise.all((sources.length?sources:[section.dataset.source]).map(async source=>{
          const url=new URL(source,location.origin);url.searchParams.set('view','jinnko-first');url.searchParams.set('sort_by','created-descending');url.searchParams.set('filter.v.availability','1');
          const preview=params.get('preview_theme_id');if(preview)url.searchParams.set('preview_theme_id',preview);
          const response=await boundedCatalogFetch(url);if(!response.ok)throw new Error('Initial products unavailable');const data=await response.json();return data.products;
        }));
        const live=Array.from(new Map(heads.flat().map(p=>[String(p.id),p])).values());
        const matching=filterCatalog(live,category,query,false);
        const first=sortCatalog(singleFilters?filterSingles(matching,selectedTypes()):matching,'default',true).slice(0,20);
        if(bootstrapRevision!==typeRevision)throw new Error('Initial selection changed');
        if(first.length){mergeSearchCards(grid,first);section.dataset.catalogReady='native';section.dataset.bootstrapReady='true';status.textContent=`${first.length} shown`;}
        } catch(e) { console.warn('JinnKo initial batch:',e.message); }
      }
      const groups = await catalogPromise;
      const all = Array.from(new Map(groups.flat().map(p=>[String(p.id),p])).values());
      if (native) native.hidden = true;
      const includeSoldOut = mode === 'collection' && (Boolean(category && category !== 'all') || (section.dataset.handle || '') !== 'all');
      let products = filterCatalog(all,category,query,includeSoldOut);
      const handle = section.dataset.handle || '';
      const sealedFirst = mode === 'collection';
      const resetButton=section.querySelector('[data-sort-reset]');
      const availableSingles=products.filter(p=>p.variantCount>0);
      const stockTypes=new Set(availableSingles.map(singleGroup));
      typeInputs.forEach(input=>{
        const available=stockTypes.has(input.dataset.singleType);
        input.disabled=!available;input.closest('label').hidden=!available;
      });
      const selectedProducts=()=>singleFilters ? filterSingles(products,selectedTypes()) : products;
      const hideExcludedCards=()=>{
        if(!singleFilters)return;
        const allowed=new Set(selectedProducts().map(p=>String(p.id)));
        if(allowed.size)grid.querySelector('.jk-empty')?.remove();
        grid.querySelectorAll('.jk-card').forEach(card=>{card.hidden=!allowed.has(card.dataset.productId);});
      };
      let ordered = [], shown = 0, renderRevision=0, moreBusy=false;
      const updateStatus=()=>{
        more.hidden=shown>=ordered.length;
        status.textContent=`${ordered.length} ${includeSoldOut?'':'in-stock '}${ordered.length===1?'product':'products'} · ${shown} shown`;
      };
      const paintMore=async(size=20)=>{
        if(moreBusy)return;
        if(!size){updateStatus();return;}
        const token=renderRevision,start=shown,batch=ordered.slice(start,start+size);
        moreBusy=true;more.disabled=true;
        try{
          const live=await hydrateProducts(batch);if(token!==renderRevision)return;
          grid.insertAdjacentHTML('beforeend',live.filter(p=>includeSoldOut||p.variantCount>0).map(p=>cardHTML(p)).join(''));shown=start+batch.length;syncCardCart();updateStatus();
        }catch(error){if(token===renderRevision)status.textContent='More products could not load. Try Load more products again.';}
        finally{if(token===renderRevision){moreBusy=false;more.disabled=false;}}
      };
      const reset=async()=>{
        const token=++renderRevision;moreBusy=true;more.hidden=true;section.setAttribute('aria-busy','true');
        ordered=sortCatalog(selectedProducts(),sort.value,sealedFirst,query);
        hideExcludedCards();
        status.textContent=`${ordered.length} ${includeSoldOut?'':'in-stock '}${ordered.length===1?'product':'products'} · ${grid.querySelectorAll('.jk-card:not([hidden])').length} shown`;
        try{
          const live=await hydrateProducts(ordered.slice(0,20));if(token!==renderRevision)return;
          mergeSearchCards(grid,live.filter(p=>includeSoldOut||p.variantCount>0));shown=Math.min(20,ordered.length);
          if(!shown)grid.innerHTML=singleFilters ? '<p class="jk-empty">No products match these types. Choose another type or use Show all types.</p>' : '<p class="jk-empty">No products found. Try a different search.</p>';
          updateStatus();
        }finally{if(token===renderRevision){moreBusy=false;more.disabled=false;section.removeAttribute('aria-busy');}}
      };
      catalogApplyTypes=reset;++typeRevision;
      sort.disabled = false;
      sort.value = !defaultOrder && ['price-ascending','price-descending','title-ascending','title-descending','created-ascending','created-descending'].includes(requestedSort) ? requestedSort : requestedSort==='title'?'title-ascending':'default';
      if(resetButton)resetButton.hidden=sort.value==='default';
      const initialCards = Array.from(grid.querySelectorAll('.jk-card[data-product-id]'));
      const keepInitial = section.dataset.catalogReady === 'native' && sort.value === 'default' && initialCards.length > 0;
      if (keepInitial) {
        // Keep loaded image nodes while merging the complete, correctly sorted list.
        // Replace a card only if its stock, price or purchasable variant changed.
        const nodes = new Map(initialCards.map(card=>[card.dataset.productId,card]));
        ordered = sortCatalog(selectedProducts(),sort.value,sealedFirst,query);
        const fragment = document.createDocumentFragment();
        const first = ordered.slice(0,20);
        const reusable = p=>{
          const existing=nodes.get(String(p.id));
          return existing && Number(existing.dataset.cardPrice)===p.price && Number(existing.dataset.cardCompare||0)===(Number(p.compareAt)||0) && Number(existing.dataset.cardAvailableCount)===p.variantCount && (!existing.dataset.cardVariant || String(p.variant)===existing.dataset.cardVariant);
        };
        // Native cards already contain live stock, price and variant choices from this page response.
        // Only missing or changed cards need a second Shopify request.
        const initialRevision=renderRevision;
        const refreshed = new Map((await hydrateProducts(first.filter(p=>!reusable(p)))).map(p=>[String(p.id),p]));
        if(initialRevision===renderRevision){
        const batch = first.filter(p=>reusable(p)||refreshed.has(String(p.id))).map(p=>refreshed.get(String(p.id))||p).filter(p=>includeSoldOut||p.variantCount>0);
        batch.forEach(p=>{
          const existing = nodes.get(String(p.id));
          if(reusable(p) && !refreshed.has(String(p.id))) {existing.hidden=false;fragment.append(existing);return;}
          const variant = p.variantCount > 0 && !p.sellingPlan ? String(p.variant) : undefined;
          const validChoice = existing && (!existing.dataset.cardVariant || existing.dataset.cardVariant === variant || (p.variants||[]).some(v=>String(v.id)===existing.dataset.cardVariant));
          const unchangedChoices = existing && Array.from(existing.querySelectorAll('[data-card-choice]')).every(b=>(p.variants||[]).some(v=>String(v.id)===b.dataset.cardChoice && v.price===Number(b.dataset.price) && (Number(v.compareAt)||0)===Number(b.dataset.compare)));
          if (existing && validChoice && unchangedChoices && Number(existing.dataset.cardPrice) === p.price && Number(existing.dataset.cardCompare || 0) === (Number(p.compareAt) || 0) && Number(existing.dataset.cardAvailableCount) === p.variantCount) {
            existing.hidden=false;fragment.append(existing);
          } else {
            const template = document.createElement('template');
            template.innerHTML = cardHTML(p); fragment.append(template.content);
          }
        });
        initialCards.forEach(card=>{if(card.parentNode === grid)card.remove();});
        grid.append(fragment); shown = batch.length; paintMore(0);
        }
      } else await reset();
      section.dataset.catalogReady = 'true';
      section.dataset.bootstrapReady='true';
      if(singleFilters){
        singleFilters.hidden=!typeInputs.some(input=>!input.disabled);
      }
      sort.addEventListener('change',()=>{
        if(resetButton)resetButton.hidden=sort.value==='default';
        const url = new URL(location.href); url.searchParams.delete('page'); url.searchParams.set('sort_by',sort.value==='default'?'created-descending':sort.value);
        url.searchParams.delete('jinnko_sort');if(sort.value==='created-descending')url.searchParams.set('jinnko_sort',sort.value);
        history.replaceState(null,'',url); reset().catch(()=>{status.textContent='Products could not be sorted. Please retry.';});
        section.scrollIntoView({block:'start',behavior:'instant'});
      });
      resetButton?.addEventListener('click',()=>{sort.value='default';sort.dispatchEvent(new Event('change'));});
      more.addEventListener('click',()=>paintMore());
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(entries=>{if(entries.some(e=>e.isIntersecting) && shown < ordered.length) paintMore();},{rootMargin:'250px'});
        observer.observe(section.querySelector('[data-catalog-sentinel]'));
      }
    } catch(e) {
      if ((category && section.dataset.catalogReady !== 'native') || mode === 'search') {
        grid.replaceChildren();
        if (native) native.hidden = true;
        status.textContent='These products could not load. Please refresh to try again.';
      } else {
        status.textContent='Refresh to load more products and enable sorting.';
      }
      section.dataset.catalogReady = 'true';
      section.dataset.bootstrapReady='true';
      if (sort) sort.disabled = true;
      console.warn('JinnKo catalog:',e.message);
    }
  }
  document.querySelectorAll('[data-jk-catalog="collection"]').forEach(startCatalog);
  // Search asks Shopify's index for this query, never downloads the store catalog.
  function mergeSearchCards(grid, products) {
    const nodes=new Map(Array.from(grid.querySelectorAll('.jk-card')).map(c=>[c.dataset.productId,c]));
    const fragment=document.createDocumentFragment();
    products.forEach((p,index)=>{
      const old=nodes.get(String(p.id));
      const choices=old&&Array.from(old.querySelectorAll('[data-card-choice]')).every(b=>(p.variants||[]).some(v=>String(v.id)===b.dataset.cardChoice&&v.price===Number(b.dataset.price)&&(Number(v.compareAt)||0)===Number(b.dataset.compare)));
      const validChoice=old&&(!old.dataset.cardVariant||(p.variants||[]).some(v=>String(v.id)===old.dataset.cardVariant));
      if(old&&choices&&validChoice&&Number(old.dataset.cardPrice)===p.price&&Number(old.dataset.cardAvailableCount)===p.variantCount&&Number(old.dataset.cardCompare||0)===(Number(p.compareAt)||0)){old.hidden=false;fragment.append(old);}
      else {const template=document.createElement('template');template.innerHTML=cardHTML(p,index<4?'eager':'lazy');fragment.append(template.content);}
    });
    grid.replaceChildren(fragment);syncCardCart();
  }
  document.querySelectorAll('[data-jk-live-search]').forEach(section=>{
    const form=section.querySelector('form'),input=form.querySelector('[name=q]'),grid=section.querySelector('[data-catalog-grid]'),sort=section.querySelector('[data-catalog-sort]'),status=section.querySelector('[data-catalog-status]'),more=section.querySelector('[data-catalog-more]');
    const cache=new Map();let controller,timer,revision=0,state,shown=0,busy=false;
    const params=new URLSearchParams(location.search);
    sort.value=['price-ascending','price-descending','title-ascending','title-descending','created-ascending','created-descending'].includes(params.get('sort_by'))?params.get('sort_by'):'default';
    section.querySelector('[data-native-pagination]').hidden=true;
    const available=()=>Array.from(state.data).sort((a,b)=>a[0]-b[0]).flatMap(p=>p[1]).filter(p=>p.variantCount>0&&Number.isFinite(p.price));
    async function fetchPage(query,page,signal) {
      const url=new URL(section.dataset.searchUrl,location.origin);url.searchParams.set('view','jinnko-data');url.searchParams.set('q',query);url.searchParams.set('type','product');url.searchParams.set('options[prefix]','last');url.searchParams.set('options[unavailable_products]','hide');url.searchParams.set('page',page);
      const preview=params.get('preview_theme_id');if(preview)url.searchParams.set('preview_theme_id',preview);
      const response=await fetch(url,{credentials:'same-origin',signal});if(!response.ok)throw new Error('Search unavailable');
      const data=await response.json();if(!Array.isArray(data.products)||!Number.isInteger(data.pages))throw new Error('Search unavailable');return data;
    }
    const paint=(size=20,reset=false)=>{
      let products=available();if(sort.value!=='default')products=sortCatalog(products,sort.value);
      shown=Math.min(products.length,reset?size:shown+size);mergeSearchCards(grid,products.slice(0,shown));
      if(!products.length)grid.innerHTML='<p class="jk-empty">No in-stock products found. Try a different search.</p>';
      const complete=state.data.size>=state.pages;
      more.hidden=complete&&shown>=products.length;
      status.textContent=complete?`${products.length} in-stock ${products.length===1?'product':'products'} · ${shown} shown`:`${shown} shown · more results available`;
    };
    async function run(query) {
      query=query.trim();const token=++revision;controller?.abort();controller=new AbortController();const signal=controller.signal;busy=true;more.hidden=true;section.setAttribute('aria-busy','true');
      const url=new URL(location.href);url.searchParams.delete('page');url.searchParams.set('q',query);url.searchParams.set('type','product');url.searchParams.set('options[prefix]','last');url.searchParams.set('options[unavailable_products]','hide');if(sort.value==='default')url.searchParams.delete('sort_by');else url.searchParams.set('sort_by',sort.value);history.replaceState(null,'',url);
      if(!query){grid.replaceChildren();status.textContent='Enter a name or part of a word to search.';busy=false;section.removeAttribute('aria-busy');return;}
      try {
        const remembered=cache.get(query);state=remembered&&Date.now()-remembered.time<15000?remembered:null;
        if(!state){const first=await fetchPage(query,1,signal);if(token!==revision)return;state={data:new Map([[1,first.products]]),pages:first.pages,time:Date.now()};cache.set(query,state);if(cache.size>20)cache.delete(cache.keys().next().value);}
        if(sort.value!=='default'&&state.data.size<state.pages){
          status.textContent='Sorting matching products…';const active=state;let next=2;
          await Promise.all(Array.from({length:Math.min(3,state.pages-1)},async()=>{while(next<=active.pages){const page=next++;if(active.data.has(page))continue;const result=await fetchPage(query,page,signal);if(token!==revision)return;active.data.set(page,result.products);}}));
        }
        if(token!==revision)return;form.dataset.searchFallback='';paint(20,true);
      } catch(error){if(error.name!=='AbortError'&&token===revision){status.textContent='Live search is unavailable. Press Search to use standard search.';form.dataset.searchFallback='true';}}
      finally {if(token===revision){busy=false;section.removeAttribute('aria-busy');}}
    }
    async function nextBatch(){
      if(busy||!state)return;
      const token=revision,active=state;busy=true;more.disabled=true;
      try {
        if(shown>=available().length&&active.data.size<active.pages){let page=1;while(active.data.has(page))page++;const result=await fetchPage(input.value.trim(),page,controller.signal);if(token!==revision)return;active.data.set(page,result.products);}
        if(token===revision)paint();
      }catch(error){if(error.name!=='AbortError'&&token===revision)status.textContent='More results could not load. Try Load more products again.';}
      finally {if(token===revision)busy=false;more.disabled=false;}
    }
    input.addEventListener('input',()=>{clearTimeout(timer);controller?.abort();revision++;timer=setTimeout(()=>run(input.value),180);});
    form.addEventListener('submit',event=>{if(form.dataset.searchFallback==='true')return;event.preventDefault();clearTimeout(timer);run(input.value);});
    sort.addEventListener('change',()=>run(input.value));more.addEventListener('click',nextBatch);
    if('IntersectionObserver' in window)new IntersectionObserver(entries=>{if(entries.some(e=>e.isIntersecting)&&!more.hidden)nextBatch();},{rootMargin:'250px'}).observe(section.querySelector('[data-catalog-sentinel]'));
    if(input.value.trim())run(input.value);
  });
  document.querySelectorAll('[data-live-suggestions]').forEach(form=>{
    const input=form.querySelector('[name=q]'),panel=form.querySelector('[data-suggestions]'),cache=new Map();let timer,controller,revision=0;
    const close=()=>{panel.hidden=true;input.setAttribute('aria-expanded','false');};
    async function suggest(){
      const query=input.value.trim(),token=++revision;controller?.abort();controller=new AbortController();
      if(query.length<2){close();return;}
      try {
        const cached=cache.get(query);let html=cached&&Date.now()-cached.time<15000?cached.html:null;
        if(!html){const url=new URL(route('search/suggest'),location.origin);url.searchParams.set('q',query);url.searchParams.set('resources[type]','product');url.searchParams.set('resources[limit]','8');url.searchParams.set('resources[options][unavailable_products]','hide');url.searchParams.set('section_id','jinnko-predictive-search');const preview=new URLSearchParams(location.search).get('preview_theme_id');if(preview)url.searchParams.set('preview_theme_id',preview);const response=await fetch(url,{credentials:'same-origin',signal:controller.signal});if(!response.ok)throw new Error('Suggestions unavailable');const doc=new DOMParser().parseFromString(await response.text(),'text/html');const results=doc.querySelector('[data-predictive-results]');if(!results)throw new Error('Suggestions unavailable');html=results.innerHTML;cache.set(query,{html,time:Date.now()});if(cache.size>30)cache.delete(cache.keys().next().value);}
        if(token!==revision||document.activeElement!==input)return;panel.innerHTML=html;panel.hidden=false;input.setAttribute('aria-expanded','true');
      }catch(error){if(error.name!=='AbortError'&&token===revision)close();}
    }
    input.addEventListener('input',()=>{clearTimeout(timer);controller?.abort();revision++;close();timer=setTimeout(suggest,150);});
    input.addEventListener('focus',()=>{if(input.value.trim().length>1)suggest();});
    form.addEventListener('keydown',event=>{if(event.key==='Escape'){close();input.focus();return;}if(panel.hidden)return;const links=Array.from(panel.querySelectorAll('a'));let index=links.indexOf(document.activeElement);if(event.key==='ArrowDown'){event.preventDefault();links[Math.min(index+1,links.length-1)]?.focus();}if(event.key==='ArrowUp'){event.preventDefault();if(index<=0)input.focus();else links[index-1].focus();}});
    form.addEventListener('focusout',event=>{if(!form.contains(event.relatedTarget))close();});
    document.addEventListener('pointerdown',event=>{if(!form.contains(event.target))close();});
    form.addEventListener('submit',close);
  });
  document.querySelectorAll('[data-jk-recommendations]').forEach(async section => {
    try {
      const url=new URL(section.dataset.recommendationsUrl,location.origin);
      url.searchParams.set('section_id','jinnko-related');url.searchParams.set('product_id',section.dataset.productId);url.searchParams.set('limit','10');
      const response=await fetch(url,{credentials:'same-origin'});if(!response.ok)return;
      const html=new DOMParser().parseFromString(await response.text(),'text/html');
      const cards=Array.from(html.querySelectorAll('.jk-card')).slice(0,4);
      if(cards.length){section.querySelector('.jk-grid').replaceChildren(...cards);section.hidden=false;syncCardCart();}
    } catch {}
  });

  const cartModal = document.querySelector('#jk-cart-modal');
  let lastCart = null, cartRevision = 0;
  let lastCartTrigger = null;
  const cartNotice = document.querySelector('[data-cart-notice]');
  let cartNoticeTimer, pendingCartHint = false, cartIntroShown = false;
  try { cartIntroShown = sessionStorage.getItem('jinnko-cart-intro-shown') === '1'; } catch {}
  function hideCartNotice() { clearTimeout(cartNoticeTimer); if(cartNotice) cartNotice.hidden=true; }
  function showCartNotice(message) {
    if(!cartNotice) { announce(message); return; }
    clearTimeout(cartNoticeTimer);
    cartNotice.querySelector('[data-cart-notice-text]').textContent=message;
    cartNotice.hidden=false;
    cartNoticeTimer=setTimeout(hideCartNotice,7000);
  }
  async function cartAPI(path,body) {
    const response = await fetch(route(path),{method:body?'POST':'GET',credentials:'same-origin',headers:body?{'Content-Type':'application/json',Accept:'application/json'}:{Accept:'application/json'},body:body?JSON.stringify(body):undefined});
    const json = await response.json();
    if (!response.ok) throw new Error(json.description || json.message || 'Unable to update your cart.');
    return json;
  }

  const cartNoteFields=[...document.querySelectorAll('[data-cart-note]')];
  let cartNoteDraft=cartNoteFields[0]?.value||'',cartNoteSaved=cartNoteDraft,cartNoteSaving=null,cartNoteTimer;
  function cartNoteMessage(message,isError=false) {
    document.querySelectorAll('[data-cart-note-status]').forEach(el=>{el.textContent=message;el.classList.toggle('jk-error',isError);});
  }
  async function saveCartNote() {
    clearTimeout(cartNoteTimer);
    if(cartNoteSaving)await cartNoteSaving;
    if(cartNoteDraft===cartNoteSaved)return;
    cartNoteSaving=(async()=>{
      while(cartNoteDraft!==cartNoteSaved) {
        const note=cartNoteDraft;
        cartNoteMessage('Saving note…');
        cartRevision++;
        const cart=await cartAPI('cart/update.js',{note});
        if((cart.note||'')!==note)throw new Error('Your note could not be saved. Please try again.');
        cartNoteSaved=note;
      }
      cartNoteMessage(cartNoteSaved?'Note saved.':'Note removed.');
    })();
    try {await cartNoteSaving;}
    catch(error){cartNoteMessage('Your note could not be saved. Please try again.',true);throw error;}
    finally {cartNoteSaving=null;}
  }
  cartNoteFields.forEach(field=>{
    field.addEventListener('input',()=>{
      cartNoteDraft=field.value;
      cartNoteFields.forEach(other=>{if(other!==field)other.value=cartNoteDraft;});
      cartNoteMessage(cartNoteDraft===cartNoteSaved?'':'Unsaved note');
      clearTimeout(cartNoteTimer);
      cartNoteTimer=setTimeout(()=>{saveCartNote().catch(()=>{});},500);
    });
    field.addEventListener('change',()=>{saveCartNote().catch(()=>{});});
  });
  document.addEventListener('submit',async event=>{
    const form=event.target;
    if(!form.elements?.namedItem('note')||form.dataset.cartNoteReady==='true')return;
    event.preventDefault();
    const button=event.submitter;
    if(button)button.disabled=true;
    try {
      await saveCartNote();
      form.dataset.cartNoteReady='true';
      if(button)button.disabled=false;
      form.requestSubmit(button||undefined);
    } catch {
      if(button)button.disabled=false;
      form.elements.namedItem('note').focus();
    }
  });

  let promoBusy = false;
  function promoCodes(cart, applicableOnly = false) {
    if(Array.isArray(cart.discount_codes)) return cart.discount_codes.filter(d=>!applicableOnly || d.applicable).map(d=>d.code);
    const applications=[...(cart.cart_level_discount_applications||[]), ...cart.items.flatMap(item=>(item.line_level_discount_allocations||item.discount_allocations||[]).map(d=>d.discount_application))];
    return [...new Set(applications.filter(d=>d?.type==='discount_code').map(d=>d.title))];
  }
  function syncPromo(cart) {
    const codes=promoCodes(cart,true);
    document.querySelectorAll('[data-promo-codes]').forEach(el=>{
      el.innerHTML=codes.map(code=>`<span class="jk-promo-chip"><span>${escape(code)}</span><button type="button" data-promo-remove="${escape(code)}" aria-label="${escape(`Remove promo code ${code}`)}">×</button></span>`).join('');
    });
    document.querySelectorAll('[data-promo-savings]').forEach(el=>{el.hidden=!cart.total_discount;el.textContent=`You saved ${money(cart.total_discount)}.`;});
  }
  function promoMessage(text, isError = false) {
    document.querySelectorAll('[data-promo-status]').forEach(el=>{el.textContent=text;el.classList.toggle('jk-error',isError);});
  }
  async function applyPromo(group, removeCode) {
    if(promoBusy)return;
    const input=group.querySelector('[data-promo-input]');
    const code=input.value.trim();
    if(removeCode===undefined && !code){promoMessage('Enter a promo code first.',true);input.focus();return;}
    promoBusy=true;
    const buttons=[...document.querySelectorAll('[data-promo-apply], [data-promo-remove], [name=checkout]')];
    const disabled=buttons.map(b=>b.disabled);
    buttons.forEach(b=>b.disabled=true);
    group.setAttribute('aria-busy','true');
    promoMessage(removeCode===undefined?'Checking code…':'Removing code…');
    try {
      await saveCartNote();
      const current=await cartAPI('cart.js');
      const codes=promoCodes(current,true).filter(c=>removeCode===undefined || c.toLowerCase()!==removeCode.toLowerCase());
      if(removeCode===undefined && !codes.some(c=>c.toLowerCase()===code.toLowerCase()))codes.push(code);
      cartRevision++;
      const cart=await cartAPI('cart/update.js',{discount:codes.join(',')});
      const applied=removeCode!==undefined || promoCodes(cart,true).some(c=>c.toLowerCase()===code.toLowerCase());
      const message=removeCode!==undefined?'Promo code removed.':applied?'Promo code applied.':'That code isn’t valid for this cart. Check the code and its requirements.';
      if(group.closest('.jk-cart-page')) {
        try{sessionStorage.setItem('jinnko-promo-feedback',JSON.stringify({message,error:!applied}));}catch{}
        location.reload();return;
      }
      drawCart(cart);
      promoMessage(message,!applied);
      if(applied)input.value='';
    } catch(err){promoMessage(err.message||'We couldn’t check that code. Please try again.',true);}
    finally {
      promoBusy=false;group.removeAttribute('aria-busy');
      buttons.forEach((b,i)=>b.disabled=disabled[i]);
      if(cartModal && lastCart)cartModal.querySelector('[name=checkout]').disabled=lastCart.item_count===0;
    }
  }
  document.addEventListener('click',e=>{
    const button=e.target.closest('[data-promo-apply], [data-promo-remove]');
    if(button){e.preventDefault();applyPromo(button.closest('[data-cart-promo]'),button.dataset.promoRemove);}
  });
  document.addEventListener('keydown',e=>{
    if(e.key==='Enter' && e.target.matches('[data-promo-input]')){e.preventDefault();applyPromo(e.target.closest('[data-cart-promo]'));}
  });
  try {
    const feedback=JSON.parse(sessionStorage.getItem('jinnko-promo-feedback')||'null');
    sessionStorage.removeItem('jinnko-promo-feedback');
    if(feedback)promoMessage(feedback.message,feedback.error);
  }catch{}

  function syncCardCart() {
    if(!lastCart) return;
    document.querySelectorAll('[data-card-variant], [data-variant-purchase]').forEach(card=>{
      const variant=card.dataset.variantPurchase||card.dataset.cardVariant;
      const item=lastCart.items.find(item=>String(item.variant_id||item.id)===variant && !item.selling_plan_allocation && !Object.values(item.properties||{}).some(Boolean));
      const quantity=item?.quantity||0;
      card.dataset.cartKey=item?.key||'';card.dataset.cartQuantity=quantity;
      const add=card.dataset.variantPurchase?card.querySelector('[data-card-choice]'):card.querySelector('.jk-add-form');
      add.hidden=quantity>0;
      const counter=card.dataset.variantPurchase?card.querySelector('.jk-variant-counter'):card.querySelector('.jk-card-action > .jk-card-counter');
      counter.hidden=quantity===0;
      counter.querySelector('[data-card-quantity]').textContent=quantity;
    });
  }
  function cartLinePrice(item) {
    const original=Number(item.original_line_price ?? item.final_line_price),final=Number(item.final_line_price);
    const allocations=item.line_level_discount_allocations||item.discount_allocations||[];
    const savings=original>final?`<s class="jk-price-before"><span class="jk-sr">Original price </span>${escape(money(original))}</s>`+(allocations.length?allocations.map(d=>`<span class="jk-price-discount">${escape(d.discount_application?.title||'Discount')}: −${escape(money(d.amount))}</span>`).join(''):`<span class="jk-price-discount">Discount: −${escape(money(original-final))}</span>`):'';
    return `${savings}<strong${original>final?' class="jk-price-reduced"':''}><span class="jk-sr">Price </span>${escape(money(final))}</strong>`;
  }
  function drawCart(cart) {
    lastCart=cart;syncCardCart();syncPromo(cart);
    document.querySelectorAll('[data-cart-count]').forEach(el=>el.textContent=cart.item_count);
    cartModal.querySelector('[data-cart-subtotal]').textContent=money(cart.total_price);
    cartModal.querySelector('[data-cart-original]').textContent=money(cart.original_total_price);
    cartModal.querySelector('[data-cart-discount]').textContent=`−${money(cart.total_discount)}`;
    cartModal.querySelectorAll('[data-cart-before-row], [data-cart-discount-row]').forEach(el=>el.hidden=!cart.total_discount);
    cartModal.querySelector('[data-cart-lines]').innerHTML=cart.items.length?cart.items.map(item=>`<div class="jk-cart-line"><a href="${safeURL(item.url)}"><img${item.image?'':' class="jk-image-unavailable"'} src="${safeURL(item.image || config.imageUnavailable)}" width="70" height="85" alt="${escape(item.image ? item.product_title : `Image unavailable for ${item.product_title}`)}"></a><div class="jk-cart-line-details"><a href="${safeURL(item.url)}">${escape(item.product_title)}</a>${item.variant_title?`<p class="jk-fine">${escape(item.variant_title)}</p>`:''}</div><div class="jk-cart-line-quantity"><label class="jk-sr" for="Cart-${escape(item.key)}">Quantity for ${escape(item.product_title)}</label><input id="Cart-${escape(item.key)}" class="jk-quantity" type="number" value="${item.quantity}" min="0" data-cart-key="${escape(item.key)}"></div><div class="jk-cart-line-purchase">${cartLinePrice(item)}${item.quantity>1?`<p class="jk-fine">${escape(money(item.final_price))} each</p>`:''}<button type="button" class="jk-link" data-cart-remove="${escape(item.key)}">Remove</button></div></div>`).join(''):'<p>Your cart is empty.</p>';
    cartModal.querySelector('[name=checkout]').disabled=cart.items.length===0;
  }
  if(cartModal) {
    const revision=cartRevision;
    cartAPI('cart.js').then(cart=>{if(revision===cartRevision)drawCart(cart);}).catch(()=>{});
  }
  async function openCart(trigger) {
    if (!cartModal || typeof cartModal.showModal !== 'function') { location.href=route('cart');return; }
    const cart=await cartAPI('cart.js'); drawCart(cart);
    hideCartNotice();
    lastCartTrigger=trigger || document.activeElement; if (!cartModal.open) cartModal.showModal();
  }
  async function addCartItem(item, trigger) {
    cartRevision++;await cartAPI('cart/add.js',{items:[item]});
    try {
      if(!cartIntroShown) {
        await openCart(trigger);cartIntroShown=true;pendingCartHint=true;
        try {sessionStorage.setItem('jinnko-cart-intro-shown','1');} catch {}
        announce('Added to your cart.');
      } else {drawCart(await cartAPI('cart.js'));showCartNotice('Added to cart.');}
    } catch {location.href=route('cart');}
  }
  function closeCart() { cartModal.close(); }
  cartModal?.addEventListener('close',()=>{
    const fallback=lastCartTrigger?.closest('[data-variant-purchase], .jk-card')?.querySelector('[data-card-step="1"]')||document.querySelector('.jk-tools [data-cart-open]');
    const trigger=lastCartTrigger?.closest('[hidden]')?fallback:lastCartTrigger;
    trigger?.focus({preventScroll:true});
    if(pendingCartHint) { pendingCartHint=false;showCartNotice('Use the Cart button to reopen your cart.'); }
  });
  document.addEventListener('click',async e=>{
    const opener=e.target.closest('[data-cart-open]');
    if (opener) { e.preventDefault(); try {await openCart(opener);} catch {location.href=route('cart');} }
    if(e.target.closest('[data-cart-close]')) closeCart();
    if(e.target.closest('[data-cart-notice-close]')) hideCartNotice();
    const choice=e.target.closest('[data-card-choice]');
    if(choice) {
      const card=choice.closest('.jk-card');
      card.querySelectorAll('[data-card-choice]').forEach(b=>b.setAttribute('aria-pressed',String(b===choice)));
      selectCardImage(card,choice);
      const field=card.querySelector('.jk-add-form [name=id]');
      if(field) {field.value=choice.dataset.cardChoice;card.dataset.cardVariant=choice.dataset.cardChoice;}
      card.querySelector('.jk-card-price').innerHTML=cardPriceHTML({price:Number(choice.dataset.price),compareAt:Number(choice.dataset.compare),variantCount:1});
      syncCardCart();
      if(choice.closest('[data-variant-purchase]')) {
        choice.disabled=true;
        try {await addCartItem({id:Number(choice.dataset.cardChoice),quantity:1},choice);}
        catch(err) {showCartNotice(err.message);announce(err.message);}
        finally {choice.disabled=false;}
      }
    }
    const cardStep=e.target.closest('[data-card-step]');
    if(cardStep) {
      const card=cardStep.closest('[data-variant-purchase], [data-card-variant]');
      const quantity=Math.max(0,Number(card.dataset.cartQuantity)+Number(cardStep.dataset.cardStep));
      const buttons=card.querySelectorAll('[data-card-step]');buttons.forEach(b=>b.disabled=true);
      try {
        cartRevision++;drawCart(await cartAPI('cart/change.js',{id:card.dataset.cartKey,quantity}));
        announce(quantity?`Cart quantity updated to ${quantity}.`:'Item removed from your cart.');
        if(quantity===0) card.querySelector('[data-card-choice], [type=submit]').focus();
      } catch(err) {showCartNotice(err.message);}
      finally {buttons.forEach(b=>b.disabled=false);}
    }
    const clear=e.target.closest('[data-cart-clear]');
    if(clear) {
      clear.disabled=true;
      const page=clear.closest('.jk-cart-page');
      const error=page?.querySelector('[data-cart-page-error]');
      if(error)error.textContent='';
      try {
        cartRevision++;
        const cart=await cartAPI('cart/clear.js',{});
        if(cartModal)drawCart(cart);
        announce('Your cart is empty.');
        if(page)location.reload();
      } catch(err) {
        if(error)error.textContent=err.message;else announce(err.message);
        clear.disabled=false;
      }
    }
    const remove=e.target.closest('[data-cart-remove]');
    if(remove) { remove.disabled=true; try { drawCart(await cartAPI('cart/change.js',{id:remove.dataset.cartRemove,quantity:0})); } catch(err) {cartModal.querySelector('[data-cart-error]').textContent=err.message;remove.disabled=false;} }
  });
  cartModal?.addEventListener('click',e=>{if(e.target===cartModal) {const r=cartModal.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)closeCart();}});
  cartModal?.addEventListener('change',async e=>{
    const field=e.target.closest('[data-cart-key]'); if(!field) return;
    const quantity=Number(field.value); if(!Number.isInteger(quantity)||quantity<0)return;
    field.disabled=true;
    try { drawCart(await cartAPI('cart/change.js',{id:field.dataset.cartKey,quantity}));cartModal.querySelector('[data-cart-error]').textContent=''; }
    catch(err) {cartModal.querySelector('[data-cart-error]').textContent=err.message;field.disabled=false;}
  });
  document.addEventListener('submit',async e=>{
    const form=e.target.closest('.jk-add-form'); if(!form)return;
    if(!cartModal || typeof cartModal.showModal!=='function')return;
    e.preventDefault(); const button=form.querySelector('[type=submit]'); button.disabled=true;
    const error=form.querySelector('[data-add-error]'); if(error)error.textContent='';
    try {
      const data=new FormData(form); const item={id:Number(data.get('id')),quantity:Number(data.get('quantity')||1)};
      if(data.get('selling_plan'))item.selling_plan=Number(data.get('selling_plan'));
      await addCartItem(item,button);
    } catch(err) {if(error)error.textContent=err.message;else {announce(err.message);button.textContent='Try again';} }
    finally {button.disabled=false;}
  });

  document.querySelectorAll('[data-jk-product]').forEach(article=>{
    article.querySelectorAll('[data-quantity-step]').forEach(button=>button.addEventListener('click',()=>{
      const input=article.querySelector('[name=quantity]');
      const min=Number(input.min)||1,max=input.max?Number(input.max):Infinity;
      input.value=Math.min(max,Math.max(min,(Number(input.value)||min)+Number(button.dataset.quantityStep)));
      input.dispatchEvent(new Event('change',{bubbles:true}));
    }));
    const select=article.querySelector('[data-variant-select]');
    if(select) {
      const variants=JSON.parse(article.querySelector('[data-product-variants]').textContent);
      const options=JSON.parse(article.querySelector('[data-product-options]').textContent);
      const buttons=article.querySelector('[data-variant-buttons]');
      const form=article.querySelector('.jk-product-form');
      const swatches={red:'#c73b40',blue:'#3b66be',green:'#4c805b',black:'#151515',white:'#fff',purple:'#8057a4',pink:'#e7a2bd',yellow:'#edcf48',orange:'#d87c31',grey:'#999',gray:'#999',brown:'#785641',sage:'#a3b291','sky blue':'#83c8ed'};
      const selected=()=>variants.find(v=>String(v.id)===select.value)||variants[0];
      const paint=()=>{
        const current=selected();
        buttons.innerHTML=options.map((name,i)=>{
          const color=/^(color|colour)$/i.test(name);
          const values=Array.from(new Set(variants.map(v=>v.options[i]))).filter(value=>variants.some(v=>v.options[i]===value && v.options.every((option,j)=>j>=i||option===current.options[j])));
          return `<fieldset class="jk-options"><legend>${escape(name)}</legend><div class="jk-option-values">${values.map(value=>`<button type="button" class="jk-option" data-option-index="${i}" data-option-value="${escape(value)}" aria-pressed="${current.options[i]===value}">${color?`<span class="jk-color" style="background:${swatches[normalize(value)]||'linear-gradient(135deg,#ddd 45%,#777 46%,#777 54%,#ddd 55%)'}"></span>`:''}${escape(value)}</button>`).join('')}</div></fieldset>`;
        }).join('');
      };
      const update=()=>{
        const option=select.selectedOptions[0];
        article.querySelector('[data-product-price]').textContent=money(Number(option.dataset.price));
        const quantity=form.querySelector('[name=quantity]');
        if(option.dataset.max) {quantity.max=option.dataset.max;quantity.value=Math.min(Number(quantity.value)||1,Number(option.dataset.max));} else quantity.removeAttribute('max');
        if(option.dataset.image){const image=article.querySelector('#jk-main-image');image.classList.remove('jk-image-unavailable');image.src=option.dataset.image;image.removeAttribute('srcset');}
        const url=new URL(location.href);url.searchParams.set('variant',select.value);history.replaceState(null,'',url);paint();
      };
      if(options.length && !(options.length===1 && options[0]==='Title' && variants.length===1 && variants[0].options[0]==='Default Title')) {paint();article.querySelector('.jk-variant-fallback').hidden=true;}
      else article.querySelector('.jk-variant-fallback').hidden=true;
      buttons.addEventListener('click',e=>{
        const b=e.target.closest('[data-option-index]');if(!b)return;
        const i=Number(b.dataset.optionIndex),value=b.dataset.optionValue,current=selected();
        const exact=variants.find(v=>v.options.every((option,j)=>option===(j===i?value:current.options[j])));
        const fallback=variants.find(v=>v.options[i]===value && v.options.every((option,j)=>j>=i||option===current.options[j]));
        const target=exact||fallback;if(target){select.value=String(target.id);update();}
      });
      select.addEventListener('change',update);
    }
    article.querySelectorAll('[data-image-src]').forEach(button=>button.addEventListener('click',()=>{const image=article.querySelector('#jk-main-image');image.classList.remove('jk-image-unavailable');image.src=button.dataset.imageSrc;image.alt=button.dataset.imageAlt;image.removeAttribute('srcset');}));
    const zoom=article.querySelector('.jk-zoom');
    article.querySelector('[data-image-zoom]')?.addEventListener('click',()=>{const original=article.querySelector('#jk-main-image');zoom.querySelector('img').src=original.currentSrc;zoom.querySelector('img').alt=original.alt;zoom.showModal();});
    zoom?.querySelector('[data-zoom-close]').addEventListener('click',()=>zoom.close());
  });

  // Fetch small random stock samples together and reveal exactly one selection.
  async function initRandomHomepage(section) {
    if (!section || section.dataset.homeReady) return;
    const started = performance.now();
    section.dataset.homeReady = 'loading';
    const grid = section.querySelector('[data-home-grid]');
    const fallback = section.querySelector('[data-home-fallback]');
    if (!grid || !fallback) return;
    const target = Math.min(15, Number(fallback.dataset.count) || fallback.content?.children.length || 15);
    const shuffle = list => {
      for (let i = list.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [list[i], list[j]] = [list[j], list[i]];
      }
      return list;
    };
    let committed = false, deadline, completed = 0;
    let pool = [];
    const controller = new AbortController();
    const commit = (html, state) => {
      if (committed || !section.isConnected) return;
      committed = true;
      clearTimeout(deadline);
      controller.abort();
      grid.innerHTML = html;
      grid.removeAttribute('aria-busy');
      section.querySelector('[data-home-status]')?.remove();
      section.dataset.homeReady = state;
      section.dataset.homeLoadMs = Math.round(performance.now() - started);
      syncCardCart();
    };
    const showRandom = () => commit(shuffle(pool).slice(0,15).map((p,i) => cardHTML(p, i < 5 ? 'eager' : 'lazy')).join(''), 'random');
    const showFallback = () => {
      if (committed) return;
      const cards = fallback.content ? Array.from(fallback.content.children) : Array.from(new DOMParser().parseFromString(fallback.textContent,'text/html').querySelectorAll('.jk-card'));
      commit(shuffle(cards).map(card => card.outerHTML).join(''), 'fallback');
    };
    deadline = setTimeout(() => { if (pool.length >= target) showRandom(); else showFallback(); }, 2000);
    const source = new URL(section.dataset.homeSource, location.origin);
    source.searchParams.set('section_id', 'jinnko-home');
    const preview = new URLSearchParams(location.search).get('preview_theme_id');
    if (preview) source.searchParams.set('preview_theme_id', preview);
    const readPage = async page => {
      const url = new URL(source); url.searchParams.set('page', page);
      const response = await fetch(url, {signal:controller.signal, credentials:'same-origin'});
      if (!response.ok) throw new Error('Homepage stock sample unavailable');
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      const sample = html.querySelector('[data-home-sample]');
      if (!sample) throw new Error('Homepage stock sample missing');
      return JSON.parse(sample.textContent);
    };
    try {
      let pages = Number(section.dataset.homePages), first;
      // Compatibility with a previously cached homepage; current pages embed this count.
      if (!Number.isInteger(pages) || pages < 1) { first = await readPage(1); pages = Math.max(1, Number(first.pages) || 1); }
      const choices = new Set();
      while (choices.size < Math.min(3, pages)) choices.add(1 + Math.floor(Math.random() * pages));
      section.dataset.homeRequestCount = choices.size + (first ? 1 : 0);
      await Promise.allSettled(Array.from(choices, async page => {
        const sample = first && page === 1 ? first : await readPage(page);
        if (committed) return;
        pool = Array.from(new Map(pool.concat(sample.products).filter(p => p.variantCount > 0 && Number.isFinite(p.price)).map(p => [String(p.id),p])).values());
        completed++;
        if (completed >= Math.min(2, choices.size) && pool.length >= target) showRandom();
      }));
      if (!committed) { if (pool.length >= target) showRandom(); else showFallback(); }
    } catch {
      showFallback();
    } finally {
      clearTimeout(deadline);
    }
  }
  document.querySelectorAll('[data-home-random]').forEach(initRandomHomepage);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-home-random]').forEach(initRandomHomepage));

})();
